/* :: Import Dependencies
{+} ---------------------------------- */
import 'gsap';
import ScrollMagic from 'scrollmagic';
import 'scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
global.ScrollMagic = ScrollMagic;

/* :: Import Local
{+} ---------------------------------- */
import Router from './util/Router';
import googleMapsInit from './util/googleMapsInit';
import tabs from './util/jquery.tabslet.min';
import steps from './util/jquery.steps.min';
import are_you_sure from './util/jquery.are-you-sure';
import core from './bootstrap';
import createGroup from './routes/create-group';
import editGroup from './routes/create-group';
import find from './routes/find-group';
import welcome from './routes/welcome';
import groupLeaders from './routes/group-leaders';
import groups from './routes/groups';


/* :: Router Setup
{+} ---------------------------------- */
const routes = new Router({
    core,
    createGroup,
    editGroup,
    find,
    welcome
});

console.log(
    `%cCrafted by https://whiteboard.is`,
    'background: #729999; color: #ffffff; font-size: 13px; padding: 4px 8px;'
);

/* :: Load!
{+} ---------------------------------- */
window.googleMapsInit = googleMapsInit;
jQuery.ajaxPrefilter( function( s ) {
    if ( s.crossDomain ) {
        s.contents.script = false;
    }
} );
jQuery(document).ready(() => routes.loadEvents());
